import React from 'react';

/**
 * Modal que avisa a un usuario EN periodo de prueba que le quedan pocos días
 * (<=5). Se muestra una vez al iniciar sesión. Indica los días restantes y que
 * debe comunicarse con el administrador para ampliar su licencia.
 *
 * Props:
 *  - dias: número de días restantes (>=0)
 *  - pruebaHasta: fecha fin de prueba (ISO "YYYY-MM-DD") | null
 *  - onClose: () => void
 */
const formatearFecha = (iso) => {
  if (!iso) return null;
  try {
    const [y, m, d] = iso.split('-').map(Number);
    const dt = new Date(y, (m || 1) - 1, d || 1);
    return dt.toLocaleDateString('es-CO', { day: '2-digit', month: 'long', year: 'numeric' });
  } catch {
    return iso;
  }
};

const AvisoPruebaModal = ({ dias, pruebaHasta, onClose }) => {
  const fecha = formatearFecha(pruebaHasta);

  let mensajeDias;
  if (dias <= 0) {
    mensajeDias = 'Hoy es tu último día de prueba gratuita de IMEC.';
  } else if (dias === 1) {
    mensajeDias = 'Te queda 1 día de prueba gratuita de IMEC.';
  } else {
    mensajeDias = `Te quedan ${dias} días de prueba gratuita de IMEC.`;
  }

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-6 text-center">
        <div className="text-5xl mb-3">⏳</div>
        <h2 className="text-2xl font-bold text-amber-700 mb-2">
          Tu periodo de prueba está por terminar
        </h2>
        <p className="text-base font-semibold text-gray-800 mb-2">{mensajeDias}</p>
        <p className="text-sm text-gray-600 mb-1">
          Para ampliar tu licencia de uso, <strong>comunícate con el administrador</strong>.
        </p>
        {fecha && (
          <p className="text-xs text-gray-400 mb-5">Tu periodo de prueba vence el {fecha}.</p>
        )}
        {!fecha && <div className="mb-5" />}
        <button
          onClick={onClose}
          className="w-full px-6 py-2.5 bg-amber-500 text-white rounded-lg hover:bg-amber-600 font-medium transition shadow"
        >
          Entendido
        </button>
      </div>
    </div>
  );
};

export default AvisoPruebaModal;
